var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.8,29.8c-6.2-8-16.6-11.5-26.3-8.9s-17.1,10.9-18.4,21s3.6,19.8,12.4,24.9s19.8,4.2,27.8-2 C91.4,56.5,93.3,40.7,84.8,29.8L84.8,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,36L62.9,46.7L60,43.6C70.4,33.2,71.3,34,73.5,36L73.5,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.9,46.9c-0.2,0-0.2,0-0.3-0.2l-3.1-3.1c-0.2-0.2-0.2-0.3,0-0.5c10.2-10.2,11.7-9.8,14.1-7.6 c0,0,0.2,0.2,0.2,0.3c0,0.2,0,0.2-0.2,0.3L63.1,46.7C63.1,46.9,63.1,46.9,62.9,46.9L62.9,46.9z M60.4,43.6l2.4,2.4L73,36 c-0.7-1-2-1.1-2.9-0.5C68.1,36.3,65.2,38.9,60.4,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66,49.6l-2.9-2.9l10.6-10.4C76.6,39.1,72.3,43.6,66,49.6L66,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,50c-0.2,0-0.2,0-0.3-0.2L62.7,47c0-0.2,0-0.2,0-0.3c0-0.2,0-0.2,0-0.3l10.6-10.6c0.2-0.2,0.3-0.2,0.5,0 c0.7,0.7,1.1,1.6,1,2.4c0,2.8-3.3,6.3-8.6,11.5C66.1,50,66.1,50,66,50L66,50z M63.5,46.5L66,49c4.2-3.9,8.1-8,8.1-10.7 c0-0.7-0.2-1.1-0.5-1.6L63.5,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,43.6l2.1,2.1c0,0,0,0,0,0.2c0,0,0,0,0,0.2l-4.4,1c-0.2,0-0.5-0.2-0.5-0.3c0-0.2,0-0.3,0.2-0.3L60,43.6 L60,43.6L60,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,47.2c-0.3,0-0.5-0.2-0.7-0.3c-0.2-0.3-0.2-0.7,0.2-1l2.6-2.6c0.2-0.2,0.5-0.2,0.7,0l2.1,2.1 c0.2,0.2,0.2,0.3,0.2,0.5c0,0.2-0.2,0.3-0.3,0.3L57.5,47.2L57.5,47.2z M60,44.1l-2.4,2.4l3.9-0.8L60,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.2,30.1c-1.5-1.5-3.9-1.5-5.5-0.2c-1.6,1.3-1.8,3.7-0.7,5.4c1.3,1.6,3.6,2.1,5.4,1.1l-2.8-2.8L79.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.2,37.4c-1.8,0-3.4-1.1-4.1-2.8c-0.7-1.6-0.3-3.6,1-4.7c1.8-1.8,4.6-1.8,6.3,0c0.2,0.2,0.2,0.3,0,0.5l0,0 l-3.4,3.3l2.6,2.4c0.2,0,0.2,0.2,0.2,0.3c0,0.2,0,0.2-0.2,0.3C77.9,37.1,77,37.4,76.2,37.4L76.2,37.4z M76.2,29.3 c-2,0-3.7,1.6-3.6,3.7c0,1,0.3,2,1.1,2.6c1.1,1.1,2.6,1.3,4.1,0.8L75.4,34c0,0-0.2-0.2-0.2-0.3c0-0.2,0-0.2,0.2-0.3l3.3-3.3 C77.9,29.6,77.2,29.3,76.2,29.3L76.2,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.2,30.1l-3.6,3.6l2.8,2.8c0.3-0.2,0.5-0.3,0.8-0.7C80.8,34.3,80.8,31.7,79.2,30.1L79.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.3,36.9c-0.2,0-0.2,0-0.3-0.2L75.2,34c0,0-0.2-0.2-0.2-0.3s0-0.2,0.2-0.3l3.6-3.4c0-0.2,0.2-0.2,0.3-0.2 c0.2,0,0.2,0,0.3,0.2c1.8,1.6,1.8,4.6,0,6.2l0,0c-0.3,0.3-0.5,0.5-0.8,0.7C78.5,36.9,78.5,36.9,78.3,36.9L78.3,36.9z M76.1,33.7 l2.4,2.4c0.2-0.2,0.3-0.2,0.5-0.3c0.7-0.7,1.1-1.6,1.1-2.6c0-0.8-0.3-1.8-1-2.4L76.1,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,36.5c-0.7-0.5-1.5-0.5-2.1,0l-9.4,9.4l1.6,1.6l10.1-8.8C74.6,38.1,74.6,37.1,73.9,36.5L73.9,36.5 L73.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,47.8c-0.2,0-0.2,0-0.3-0.2L61.9,46c-0.2-0.2-0.2-0.3,0-0.5l9.4-9.4c0.8-0.8,2-0.8,2.8,0 c0.3,0.3,0.7,1,0.5,1.5c0,0.5-0.3,1-0.7,1.3l-10.1,8.8C64,47.8,63.9,47.8,63.9,47.8L63.9,47.8z M62.7,45.9l1,1l9.8-8.6 c0.3-0.2,0.3-0.5,0.3-0.8c0-0.3-0.2-0.7-0.3-0.8c-0.5-0.5-1.1-0.5-1.6,0L62.7,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,56.6c0,0,0,0.2,0,0.3l0.5,1.8c0,0.2,0,0.5-0.3,0.5c-0.2,0.2-0.5,0.2-0.7,0l-2.9-2.8l8.9-8.9h3.1l2.1,2.1 C62.6,52.4,59,54.8,55.1,56.6L55.1,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,59.7c-0.2,0-0.5-0.2-0.7-0.3l-2.8-2.8c0,0-0.2-0.2-0.2-0.3s0-0.2,0.2-0.3l8.9-8.9l0.2-0.2h3.1 c0,0,0.2,0,0.3,0l2.1,2.1c0,0,0.2,0.2,0.2,0.3c0,0.2,0,0.2-0.2,0.3L66,50c-3.3,2.8-6.8,5-10.7,6.8l0.5,1.6c0,0.3,0,0.5-0.2,0.8 C55.4,59.5,55.1,59.5,54.9,59.7L54.9,59.7z M52.3,56.5l2.4,2.4h0.2v-0.2l-0.3-1.8c0-0.3,0-0.5,0.3-0.7c3.7-1.8,7.3-4.1,10.4-6.7 l-1.8-1.8h-2.8L52.3,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,58.6l2.1-2.1l3.3,3.3l-5.2-0.3c-0.2,0-0.3-0.2-0.3-0.5C49.4,58.7,49.6,58.6,49.6,58.6L49.6,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,60l-5-0.3c-0.5,0-0.8-0.5-0.7-0.8c0-0.2,0.2-0.3,0.2-0.5l2.1-2.1c0.2-0.2,0.3-0.2,0.5,0l3.3,3.3 c0.2,0.2,0.2,0.3,0,0.5C55.1,59.9,55.1,60,54.9,60L54.9,60z M49.9,58.9l4.2,0.3l-2.3-2.1L49.9,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,47.7l-4.2,0.7l2.4-2.4L64,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,48.7c-0.2,0-0.3,0-0.3-0.2c0-0.2,0-0.3,0-0.3l2.4-2.4c0.2-0.2,0.3-0.2,0.5,0l1.8,1.8c0,0.2,0,0.3,0,0.3 c0,0.2-0.2,0.3-0.3,0.3L59.8,48.7L59.8,48.7z M62.2,46.4l-1.3,1.3l2.3-0.3L62.2,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,47.7L61.1,48c-0.2,0-0.3,0-0.5-0.2c-0.2-0.2,0-0.3,0-0.5l1.5-1.5L64,47.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostman);
export default __webpack_public_path__ + "static/media/Postman.84294bb1196ecf32076ccb43546be371.svg";
export { ForwardRef as ReactComponent };